export default __webpack_public_path__ + "static/media/profile7.3b667596.png";